import { render, staticRenderFns } from "./CostumerAdofa.vue?vue&type=template&id=06f3c347&"
import script from "./CostumerAdofa.vue?vue&type=script&lang=js&"
export * from "./CostumerAdofa.vue?vue&type=script&lang=js&"
import style0 from "./CostumerAdofa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports